// extracted by mini-css-extract-plugin
export var carrierIcon = "_tm-0";
export var carrierLogo = "_tm-1";
export var detailsSection = "_tm-2";